import { useMemo } from "react";
import { useAppData } from "../contexts/appData.context";

export const useCustomer = () => {
    const { cvrAndCustomerNumbers, customerNumber } = useAppData();

    const customer = useMemo(
        () =>
            cvrAndCustomerNumbers?.accounts?.find((x) =>
                x.customers?.find((y) => y.number === customerNumber)
            ),
        [cvrAndCustomerNumbers, customerNumber]
    );

    const quickPayOnly = useMemo(() => {
        const customer = cvrAndCustomerNumbers?.accounts
            ?.flatMap((account) => account.customers)
            .find((customer) => customer.number === customerNumber);
        return customer?.quickpayOnly || false;
    }, [cvrAndCustomerNumbers, customerNumber]);

    const allowedPaymentMethod = useMemo(() => {
        const customer = cvrAndCustomerNumbers?.accounts
            ?.flatMap((account) => account.customers)
            .find((customer) => customer.number === customerNumber);
        return customer?.allowedPaymentMethod || "";
    }, [cvrAndCustomerNumbers, customerNumber]);

    // const [allowedPaymentMethod, setAllowedPaymentMethod] = useMemo(() => {
    //     const customer = cvrAndCustomerNumbers?.accounts
    //         ?.flatMap((account) => account.customers)
    //         .find((customer) => customer.number === customerNumber);
    //     return customer?.allowedPaymentMethod || "";
    // }, [cvrAndCustomerNumbers, customerNumber]);

    // console.log('CUSTOMER HOOK', customer, customerNumber, quickPayOnly, allowedPaymentMethod);

    return {
        customer,
        customerNumber,
        quickPayOnly,
        allowedPaymentMethod,
    };
};
